import moment from "moment";
import 'react-js-cron/dist/styles.css'
import React, { useEffect, useState } from "react";
import { Container, Button } from "react-bootstrap";
import { Check, ChevronDown, ChevronUp, Play, Radio, Square, X } from "lucide-react";
import automationClient from "lib/automation-client";
import ErrorModal from "components/Model/AutomationErrorModal";
import TerminalModal from "components/Model/AutomationTerminalModal";
import socket from "socket";
import ProcessLogTable from "components/Automation/ProcessLogTable";
import DeleteComponent from "components/Event/DeleteComponent";
import UpdateInsertModal from "components/Model/UpdateInsertModal";

const intialState = { automationName: '', expression: '0 0 * * *', status: "inactive", name: '', params: [], isLive: false,middlewareDB:'demo',proDB:'qa', truncate:false }
const AutomationPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [deleteComponent, setSetDeleteComponent] = useState(undefined);
  const [params, setParams] = useState([])
  const [isEditing, setIsEditing] = useState(false);
  const [isShowPastLog, setIsShowPastLog] = useState(undefined);
  const [search, setSearch] = useState("");
  const [requestData, setRequestData] = useState({ ...intialState })
  const [cronList, setCronList] = useState([])
  const [filterCron, setFilterCron] = useState([])

  const handleAddField = (e) => {
    e.preventDefault()
    setParams([...params, { name: '', value: '' }]);
  };
  const handleChange = (index, field, newValue) => {
    const updatedFields = [...params];
    updatedFields[index][field] = newValue;
    setParams(updatedFields);
  };

  const updateTable = (data) => {
    setCronList(cronList => cronList.map(_state => _state.automationName === data.automationName ? { ..._state, ...data.payload, error: undefined } : { ..._state }))
  }

  React.useEffect(() => {
    socket.on('play-toggle-event', updateTable)
  }, [])

  const handleCancelDelete = () => setSetDeleteComponent(undefined)
  const loadParam = async () => {
    const { data } = await automationClient.loadParamsAction(requestData.automationName)
    console.log(data)
    const result = [];
    const merged = [...data, ...params];
    for (const item of merged) {
      const exists = result.findIndex(entry => entry.name === item.name);
      console.log(exists)
      if (exists == -1) {
        result.push(item);
      } else if (exists > -1) {
        const element = result[exists]
        if (!element.value && element.value == "" && item.value && item.value != "") {
          result[exists] = item
        }
      }
    }
    setParams(result)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cron = requestData.status === 'active'
    const reqData = { ...requestData, cron, params }
    const { data, error } = await automationClient.updateCreateCron(reqData)
    if (error) {
      return
    }
    setCronList(prevList => {
      const exists = prevList.some(item => item.automationName === reqData.automationName);

      if (exists) {
        return prevList.map(item =>
          item.automationName === reqData.automationName ? { ...item, ...reqData, updateAt: moment().format() } : item
        );
      } else {
        return [reqData, ...prevList];
      }
    });
    handleClose()
  }

  const fetchCronData = async () => {
    const { data, error } = await automationClient.cronListClient()
    if (error) {
      return
    }
    setCronList(data)
    setFilterCron(data)
  }
  const runManual = async (automationName) => {
    const request = { automationName }
    const { data, error } = await automationClient.runManualClient(request)
    if (error) {
      return
    }
    // update
    // const updateCronData = cronList.map(_state => _state.automationName === automationName ? { ..._state, process: true, error: undefined } : { ..._state })
    // setCronList(updateCronData)
  }
  const stopManual = async () => {

    const { data, error } = await automationClient.destroy(deleteComponent)
    if (error) {
      return
    }
    handleCancelDelete()
    // update
    // const updateCronData = cronList.map(_state => _state.automationName === automationName ? { ..._state, process: false } : { ..._state })
    // setCronList(updateCronData)
  }

  useEffect(() => {
    fetchCronData()
  }, []);

  const handleShow = () => setShowModal(true);
  const handleClose = () => {
    setShowModal(false);
    setIsEditing(false);
    setRequestData({ ...intialState });
    setParams([])
  };

  const handleInputChange = (name, value) => {
    setRequestData({ ...requestData, [name]: value });
  };



  const handleEdit = (cronItem) => {
    setIsEditing(true);
    const { automationName, name, cron, expression, params, isLive, middlewareDB,truncate,
      proDB } = cronItem
    setRequestData({
      automationName, name, status: cron ? 'active' : 'inactive', expression, params, isLive: isLive === true ? true : false, middlewareDB,
      proDB, truncate:truncate === true ? true : false
    });
    setParams(params ?? [])
    handleShow();
  };
  useEffect(() => {
    if (search) {
      const lowerSearch = search.toLowerCase();

      const matchedTags = cronList.filter(tag =>
        tag.name?.toLowerCase().includes(lowerSearch) ||
        tag.automationName?.toLowerCase().includes(lowerSearch)
      );
      setFilterCron(matchedTags)
    } else {
      setFilterCron(cronList)
    }
  }, [search, cronList])

  return (
    <>
      <DeleteComponent
        question={"Are you want to stop Automation process?"}
        title={"STOP"}
        open={Boolean(deleteComponent)}
        handleCancelDelete={handleCancelDelete}
        handleConfirmDelete={stopManual}
        acceptBtnText={"Stop"}
      />
      <Container fluid className="px-4">
        <div className="row mt-3">
          <div className="col-12 mb-3 d-flex justify-content-end gap-4">
            <input
              type="text"
              placeholder="Search ..."
              style={{ width: "15%", marginRight: "20px" }}
              onChange={(e) => setSearch(e.target.value)}
              className="form-control form-control-sm me-2"
            />
            <Button
              className="btn btn-primary btn-sm"
              style={{ marginRight: "10px" }}
              onClick={handleShow}
            >
              Create
            </Button>
            <div className="d-flex align-items-center gap-1">
              <h5>Total: {cronList?.length}</h5>
            </div>
          </div>
          <div className="col-12">
            <div className="smartTable-tableContainer-ipAddressTable">
              <table className="smartTable-table table table-striped border table-bordered table-hover">
                <thead className="smartTable-thead thead-dark" style={{ position: 'sticky', top: '0' }}>
                  <tr>
                    <th>Name</th>
                    <th>Collection Name</th>
                    <th>Cron</th>
                    <th>Is Active</th>
                    <th>Last Executing Time</th>
                    <th>UpdateAt</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filterCron?.map((list, index) => (
                    <>
                      <tr key={index}>
                        <td>
                          {
                            isShowPastLog === index ?
                              <Button className="btn p-0 mr-1" variant="link" onClick={() => setIsShowPastLog(undefined)}><ChevronUp /></Button>
                              :
                              <Button className="btn p-0 mr-1" variant="link" onClick={() => setIsShowPastLog(index)}><ChevronDown /></Button>
                          }
                          {list?.name}
                          {list?.isLive === true && <sup><Radio className="ml-1" stroke="red" /></sup>}
                        </td>
                        <td>{list?.automationName}</td>
                        <td>{list?.expression}</td>
                        <td>{list?.cron ? <Check /> : <X />}</td>
                        <td>{list?.startTime ? moment(list?.startTime).format('lll') : '-'} - {list?.endTime && `(${moment.duration(moment(list?.endTime).diff(list?.startTime)).humanize()})`}</td>
                        <td>{list?.updateAt ? moment(list?.updateAt).format('lll') : '-'}</td>
                        <td>
                          <div className="d-flex ">
                            {list?.process ?
                              <Button
                                className="btn"
                                onClick={() => setSetDeleteComponent(list.automationName)}
                                style={{ marginRight: "10px" }}
                                variant="link"
                              >
                                <Square />
                              </Button>
                              : <Button
                                className="btn "
                                onClick={() => runManual(list.automationName)}
                                style={{ marginRight: "10px" }}
                                variant="link"
                              >
                                <Play />
                              </Button>}

                            <Button
                              className="btn btn-warning btn-sm"
                              onClick={() => handleEdit(list)}
                              style={{ marginRight: "10px" }}
                            >
                              Edit
                            </Button>
                            {
                              list?.error && <ErrorModal error={list.error} startTime={list?.startTime} />
                            }
                            <TerminalModal automationName={list?.automationName} processId={list?.processId} />
                          </div>
                        </td>
                      </tr>
                      {
                        isShowPastLog === index && <ProcessLogTable automationName={list?.automationName} />
                      }
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <UpdateInsertModal handleSubmit={handleSubmit} loadParam={loadParam} handleAddField={handleAddField} showModal={showModal} handleClose={handleClose} isEditing={isEditing} requestData={requestData} handleInputChange={handleInputChange} params={params} handleChange={handleChange} />
      </Container>
    </>
  );
};
export default AutomationPage;




